import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function ThunderIcon(props: IIcon) {
    const newViewProps = '0 0 16 16' ?? props.viewBox;
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={newViewProps}
            style={props.style}
            className={props.className}
        >
            <path d="M6.409 15.962c.212.09.458.015.581-.18l5.625-8.938a.47.47 0 0 0-.396-.719H8.465L9.86.585A.47.47 0 0 0 9.01.217L3.385 9.156a.469.469 0 0 0 .396.719h3.754l-1.396 5.54a.47.47 0 0 0 .27.547z" />
        </Icon>
    );
}
